import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/custom.css";
import AppShell from "./components/AppShell";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Surveys from "./pages/Surveys";
import Rewards from "./pages/Rewards";
import Profile from "./pages/Profile";
import History from "./pages/History";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import ForgotPassword from "./pages/ForgotPassword";
import ProtectedRoute from "./components/ProtectedRoute";

function ProtectedPage({ children }) { return <ProtectedRoute><AppShell>{children}</AppShell></ProtectedRoute>; }
function AppContent() {
  const location = useLocation();
  return <Routes location={location}>
    <Route path="/" element={<Navigate to="/login" replace/>}/>
    <Route path="/login" element={<Login/>}/>
    <Route path="/signup" element={<Signup/>}/>
    <Route path="/forgotpassword" element={<ForgotPassword/>}/>
    <Route path="/terms" element={<Terms/>}/>
    <Route path="/privacy" element={<Privacy/>}/>
    <Route path="/dashboard" element={<ProtectedPage><Dashboard/></ProtectedPage>}/>
    <Route path="/surveys" element={<ProtectedPage><Surveys/></ProtectedPage>}/>
    <Route path="/rewards" element={<ProtectedPage><Rewards/></ProtectedPage>}/>
    <Route path="/history" element={<ProtectedPage><History/></ProtectedPage>}/>
    <Route path="/profile" element={<ProtectedPage><Profile/></ProtectedPage>}/>
    <Route path="*" element={<Navigate to="/dashboard" replace/>}/>
  </Routes>;
}
export default function App() { return <Router><AppContent/><ToastContainer position="top-right" autoClose={3500} newestOnTop closeOnClick pauseOnHover draggable theme="light"/></Router>; }
